import { render } from "./PasswordGenerator.vue?vue&type=template&id=188dbe5c"
import script from "./PasswordGenerator.vue?vue&type=script&lang=js"
export * from "./PasswordGenerator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__